/*
*###############################################################################
*Module Name                   : DPPermission.js                               #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Minol Prageesha                              #
*Date                          : Friday, October 29th 2021, 11:08:32 am        #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Button, Container, img, CardText, Alert } from "reactstrap"

// import images

//import Logo from "assets/images/logo/Logo.png"
//import Logo from "../../assets/images/logo/cargills.png";
//import Logo from "../../assets/images/logo/mySky.png";

//check active client
const host = window.location.protocol + "//" + window.location.host;
import Config, { ActiveClient } from "../../config";
var LogoSet = (ActiveClient) ? Config[ActiveClient] : Config["cargills"];
//console.log(LogoSet);

var Logo;
import(`assets/images/logo/${LogoSet.logo}`).then(data => {
    Logo = host + data.default; //console.log(logo);
});

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert"
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"
import DPTextBox from 'framework/components/DPTextBox';
import { Text, Numeric } from 'framework/validators/TextValidation';
import DPButton from './DPButton';
import uuid from 'react-uuid'
import { set } from 'lodash';
import { useHistory } from 'react-router-dom';

const DPOTP = ({ confirm_both, title, onConfirm, accept, onCancel, onReset, showCancel,
    btnColor, cancelColor, ErrorMsg, uitype, usercode, usernameEnable, setUsernameEnable }) => {

    let htmlTitle = <h3 style={{ color: "#2A3042" }}>{title}</h3>

    const [OTP, setOTP] = useState('')
    const [otpCode, setOtpCode] = useState('')
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [strUsername, setStrUsername] = useState('')
    let history = useHistory();

    var ucode = ''
    useEffect(async () => {

        if (confirm_both && usercode != '') {

            generatetoken(usercode)
            setStrUsername(usercode)

        }

    }, [confirm_both])


    function randomIntFromInterval(min, max) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
    }

    function acceptOTP() {

        if (OTP == otpCode) {
            setShow(true)
            setAlertMsg('Please wait...')
            setAlertColor('success')
            setTimeout(() => {
                setShow(false)
                onCancel()
                setStrUsername('')
                if (uitype == 'forgot') {
                    localStorage.setItem("ui", '1')
                }


                // window.location.href = '/forgot-password?' + strUsername
                history.push('/forgot-password?' + strUsername)
            }, 2000)
        } else {
            setShow(true)
            setAlertMsg('Invalid OTP')
            setAlertColor('danger')
            setTimeout(() => {
                setShow(false)
            }, 3000)
        }
    }

    async function generatetoken(usercode) {

        ucode = randomIntFromInterval(100000, 999999)
        var message = ''
        var username = ''
        var password = ''
        var port = ''
        var gateway = ''

        setOtpCode(ucode)

        const ApiURL = window.Links.ApiURL
        const authToken = localStorage.getItem("authToken")
        var authtoken = ''

        await fetch(`${ApiURL}login/${usercode}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }).then(Response => Response.json())
            .then(responseData => {
                authtoken = responseData.token
            }).catch(error => {
                console.log(error)
            })

        await fetch(`${ApiURL}SetupDet/setupDet`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authtoken}`
            },
        }).then(Response => Response.json())
            .then(responseData => {
                var dt = responseData.data[0]
                message = dt.msgOTP
                username = dt.smsUsername
                password = dt.smsPassword
                port = dt.smsmask
                gateway = dt.smsGateway

            }).catch(error => {
                console.log(error)
            })

        var mobileNum = ''
        await fetch(`${ApiURL}login/userdetails/${usercode}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authtoken}`
            },
        }).then(Response => Response.json())
            .then(responseData => {
                var dt = responseData.data[0]
                mobileNum = dt.mobile
                mobileNum = '94' + mobileNum.substring(1, mobileNum.length)

            }).catch(error => {
                console.log(error)
            })


        message = message.replace("{#otp#}", ucode)
        var bodyvalue = {
            "mobile": mobileNum,
            "mt_port": port,
            "msg": message,
            "u_name": username,
            "passwd": password,
            "gateway": gateway
        }

        await fetch(`${ApiURL}login/onetimepassword`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(bodyvalue)
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.data.error == 0) {
                    setShow(true)
                    setAlertMsg('OTP sent successfully')
                    setAlertColor('success')
                    setTimeout(() => {
                        setShow(false)
                    }, 3000)
                } else if (responseData.data.error != 0) {
                    setShow(true)
                    setAlertMsg('SMS Gateway Error')
                    setAlertColor('danger')
                    setTimeout(() => {
                        setShow(false)
                    }, 3000)
                }
            }).catch(error => {
                console.log(error)
            })

    }

    async function validateUsername() {
        const ApiURL = window.Links.ApiURL
        if (strUsername != '') {
            await fetch(`${ApiURL}login/${strUsername}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(Response => Response.json())
                .then(responseData => {
                    if (responseData.success) {
                        // setShow(true)
                        // setAlertMsg('Enter OTP')
                        // setAlertColor('success')
                        generatetoken(strUsername)
                        // setTimeout(() => {
                        //     setShow(false)
                        // }, 3000)
                        setUsernameEnable(false)
                    } else {
                        setShow(true)
                        setAlertMsg('Invalid Username!')
                        setAlertColor('danger')
                        setStrUsername('')
                        setTimeout(() => {
                            setShow(false)
                        }, 3000)
                    }
                }).catch(error => {
                    console.log(error)
                })
        } else {
            setShow(true)
            setAlertMsg('Please Enter Username!')
            setAlertColor('danger')
            setTimeout(() => {
                setShow(false)
            }, 3000)
        }
    }


    return (
        <div>
            {confirm_both ? (
                <SweetAlert
                    title={""}
                    custom

                    customIcon={""}
                    showCancel={showCancel}
                    confirmBtnBsStyle={btnColor}
                    cancelBtnBsStyle={cancelColor}
                    onConfirm={onConfirm}
                    onCancel={onCancel}
                    closeOnClickOutside={false}
                    customButtons={
                        <Row>
                            <Col>
                                <Button
                                    size='lg'
                                    onClick={() => {
                                        setOTP('')
                                        onCancel()
                                        setStrUsername('')
                                    }}
                                    color='danger'
                                    style={{ minWidth: '130px' }}
                                >Cancel</Button>
                            </Col>

                            {usernameEnable == false ? <Col>
                                <Button
                                    size='lg'
                                    onClick={acceptOTP}
                                    color='success'
                                    style={{ minWidth: '130px' }}
                                >OK</Button>
                            </Col> : null}

                            {usernameEnable ? <Col>
                                <Button
                                    size='lg'
                                    color="primary"
                                    style={{ minWidth: '130px' }}
                                    onClick={() => {
                                        validateUsername()
                                        //setUsernameEnable(false)
                                    }}
                                >
                                    Send OTP
                                </Button>
                            </Col> : null}

                        </Row>
                    }
                >
                    <React.Fragment>
                        <Row>
                        </Row>
                        <Row>
                            <Col sm="4" >
                                <Row >
                                </Row>
                            </Col>
                            <Col sm="4" >
                                <img
                                    src={Logo}
                                    alt=""
                                    className=""
                                    height="30"
                                />
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                        </Row>
                        <Row>
                            <Col>
                                <CardText className="mb-0">
                                    {usernameEnable ? <Row>
                                        <Col sm={12} md={12} className="mb-4-sm">
                                            <DPTextBox
                                                rowClass="mb-4-sm"
                                                labelText="User Name"
                                                textType="text"
                                                value={strUsername}
                                                onChange={(e) => {
                                                    var val = Text(e.target, 50, true, false, "camel", false)
                                                    setStrUsername(val)
                                                }}
                                            />
                                        </Col>
                                    </Row> : null}

                                    {usernameEnable == false ? <Row>
                                        <Col sm={12} md={12} className="mb-4-sm">
                                            <DPTextBox
                                                rowClass="mb-4-sm"
                                                labelText="OTP"
                                                textType="text"
                                                maxLength="20"
                                                value={OTP}
                                                disabled={usernameEnable}
                                                onChange={(e) => {
                                                    var val = Numeric(e.target, 6, 0, false)
                                                    setOTP(val)
                                                }}
                                            />
                                        </Col>
                                    </Row> : null}
                                </CardText>
                            </Col>
                        </Row>
                    </React.Fragment>

                </SweetAlert >
            ) : null}
        </div >
    );
}
export default DPOTP;